/* TradePro Floating Support Widget v1 */
/* TradePro Clean Chat Integration v1 */
/* TradePro Mobile Support Edge Tab v1 */

(function () {
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function getStorageValue(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function setStorageValue(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      return;
    }
  }

  function closeWidget(widget) {
    var button = widget.querySelector('[data-tradepro-support-toggle]');
    var panel = widget.querySelector('[data-tradepro-support-panel]');

    widget.classList.remove('is-open');

    if (button) {
      button.setAttribute('aria-expanded', 'false');
    }

    if (panel) {
      panel.setAttribute('hidden', 'hidden');
    }
  }

  function openWidget(widget) {
    var button = widget.querySelector('[data-tradepro-support-toggle]');
    var panel = widget.querySelector('[data-tradepro-support-panel]');

    widget.classList.remove('is-peeking');
    widget.classList.remove('is-minimized');
    widget.classList.add('is-open');

    if (button) {
      button.setAttribute('aria-expanded', 'true');
    }

    if (panel) {
      panel.removeAttribute('hidden');
    }
  }

  function minimizeWidget(widget) {
    var pageKey = 'tradeproSupportDismissed:' + window.location.pathname;

    closeWidget(widget);
    widget.classList.remove('is-peeking');
    widget.classList.add('is-minimized');

    setStorageValue(pageKey, '1');
  }

  function handleChatTrigger(trigger, widget) {
    var customSelector = trigger.getAttribute('data-tradepro-chat-selector');

    if (!customSelector) {
      return;
    }

    var customTarget = document.querySelector(customSelector);

    if (customTarget) {
      customTarget.click();
      closeWidget(widget);
    }
  }

  function maybeAutoPeek(widget) {
    var isEdge = widget.getAttribute('data-tradepro-support-mobile-edge') === 'true';
    var shouldAutoPeek = widget.getAttribute('data-tradepro-support-auto-peek') === 'true';
    var pageType = widget.getAttribute('data-tradepro-support-page-type');
    var delay = parseInt(widget.getAttribute('data-tradepro-support-peek-delay') || '1500', 10);
    var duration = parseInt(widget.getAttribute('data-tradepro-support-peek-duration') || '4500', 10);
    var pageKey = 'tradeproSupportPeeked:' + window.location.pathname;
    var dismissedKey = 'tradeproSupportDismissed:' + window.location.pathname;

    if (!isEdge || !shouldAutoPeek || pageType !== 'product') return;
    if (!mobileQuery.matches) return;
    if (getStorageValue(pageKey) === '1') return;
    if (getStorageValue(dismissedKey) === '1') return;

    setStorageValue(pageKey, '1');

    window.setTimeout(function () {
      if (!mobileQuery.matches) return;
      if (widget.classList.contains('is-open')) return;
      if (getStorageValue(dismissedKey) === '1') return;

      widget.classList.add('is-peeking');

      window.setTimeout(function () {
        if (!widget.classList.contains('is-open')) {
          widget.classList.remove('is-peeking');
        }
      }, duration);
    }, delay);
  }

  function initSupportWidgets() {
    var widgets = document.querySelectorAll('[data-tradepro-support-widget]');

    widgets.forEach(function (widget) {
      if (widget.dataset.tradeproSupportReady === 'true') return;
      widget.dataset.tradeproSupportReady = 'true';

      var button = widget.querySelector('[data-tradepro-support-toggle]');
      var close = widget.querySelector('[data-tradepro-support-close]');
      var minimize = widget.querySelector('[data-tradepro-support-minimize]');

      if (button) {
        button.addEventListener('click', function () {
          if (widget.classList.contains('is-open')) {
            closeWidget(widget);
          } else {
            openWidget(widget);
          }
        });
      }

      if (close) {
        close.addEventListener('click', function () {
          closeWidget(widget);
        });
      }

      if (minimize) {
        minimize.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          minimizeWidget(widget);
        });
      }

      widget.querySelectorAll('[data-tradepro-chat-trigger]').forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          handleChatTrigger(trigger, widget);
        });
      });

      document.addEventListener('click', function (event) {
        if (!widget.classList.contains('is-open')) return;
        if (widget.contains(event.target)) return;
        closeWidget(widget);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeWidget(widget);
        }
      });

      maybeAutoPeek(widget);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSupportWidgets);
  } else {
    initSupportWidgets();
  }

  document.addEventListener('shopify:section:load', initSupportWidgets);
})();
